import { Component, Input } from '@angular/core';

/// Envoltorio reutilizable de "título h3 + p-chart, pintado solo si hay datos": las tres gráficas
/// que aparecen tanto en "Visión global" como en su pestaña de detalle ("Tráfico y errores",
/// "Tiempo de respuesta", "Base de datos") usan este mismo componente en ambos sitios, en vez de
/// repetir el bloque de plantilla.
///
/// 'chart' ya viene construido por el padre (PlatformHealthDashboardComponent.buildChart /
/// buildCharts): este componente no construye nada, solo decide si lo pinta. Si 'chart' es null y
/// hay un 'emptyMessage', se muestra ese motivo en vez de dejar el hueco vacío (caso del Pool
/// elástico: el inquilino SÍ tiene pool pero ese periodo no trajo puntos).
@Component({
    selector: 'app-platform-health-chart',
    templateUrl: './platform-health-chart.component.html',
    styleUrls: ['./platform-health-chart.component.scss'],
    standalone: false
})
export class PlatformHealthChartComponent {
    @Input() public title = '';
    @Input() public chart: any = null;
    @Input() public options: any = null;
    @Input() public emptyMessage: string | null = null;
    /// Texto de ayuda contextual, opcional: igual que en app-platform-health-indicator, si no se
    /// pasa no se pinta el icono.
    @Input() public helpText: string | null = null;
}
